import {
  getLearningApiClientFunctions,
  ILearning,
} from "@kunduz/data-access-learning-api";
import { GetServerSideProps } from "next";
import { getSelectorsByUserAgent } from "react-device-detect";
import PathPage, {
  PathPageProps,
} from "../../domains/learning/pages/pathPage/pathPage";
import { serverSideTranslations } from "../../common/utility/serverSideTranslations";
import { getCachedHeaderItems } from "../../common/services/cachedHeaderItems";
import { getCachedHeaderBanner } from "../../common/services/cachedHeaderBanner";

export default function HazirlikPage(props: PathPageProps) {
  return (
    <PathPage
      isMobile={props.isMobile}
      lang={props.lang}
      currentPage={props.currentPage}
      isAuth={props.isAuth}
      modules={props.modules}
      pageMeta={props.pageMeta}
      pathDetailSlug={props.pathDetailSlug}
      perPage={props.perPage}
      headerItems={props.headerItems}
      headerBanner={props.headerBanner}
    />
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  res,
  query,
}) => {
  const { isMobile } = getSelectorsByUserAgent(req.headers["user-agent"]);
  const lang = "tr";
  const { kz_user_token } = req.cookies;

  const page = Number((query.page as string) || "1");
  const perPage = 12;

  const learningApiClientFunctions = getLearningApiClientFunctions();

  const pageMeta =
    await learningApiClientFunctions.getContentBySlug<ILearning.PathDetailResponse>(
      "paths",
      query.pathDetailSlug as string,
    );

  if (!pageMeta) {
    return {
      notFound: true,
    };
  }

  const pathModulesResult =
    await learningApiClientFunctions.getLearningPathModules({
      id: pageMeta.id,
      page,
      size: perPage,
    });

  if (!pathModulesResult) {
    return {
      notFound: true,
    };
  }
  const headerItems = await getCachedHeaderItems(lang, "student");
  const headerBanner = await getCachedHeaderBanner(lang);

  return {
    props: {
      isMobile,
      isAuth: !!kz_user_token,
      lang,
      modules: pathModulesResult,
      currentPage: page,
      perPage,
      pageMeta,
      pathDetailSlug: query.pathDetailSlug,
      headerItems,
      headerBanner,
      ...(await serverSideTranslations(lang, [
        "questionIndexing",
        "kunduzcom_learning",
        "kunduzcom_common",
      ])),
    },
  };
};
